import { CurrencyPipe, NgFor, NgIf } from '@angular/common';
import { Component } from '@angular/core';
import { filter } from 'rxjs';
import { FadeInOut } from 'src/app/animations/fade';
import { TitleExtractorPipe } from 'src/app/pipe/product-title.pipe';
import { ThemeService } from 'src/app/service/theme.service';
@Component({
    selector: 'app-toast',
    animations: [FadeInOut(500, 500, false)],
    imports: [NgFor, CurrencyPipe, NgIf, TitleExtractorPipe],
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss'
})
export class ToastComponent {
  constructor(private themeService: ThemeService) {
    this.themeService.themeEvents
      .pipe(filter((x: any) => x.type === 'deploy'))
      .subscribe((data: any) => {
        try {
          let id = Date().valueOf();
          for (let line of data.payload.cart.data.cartLinesAdd.cart.lines.edges.map(
            (x: any) => x.node
          )) {
            if (
              line.merchandise.id &&
              data.payload.variantIds.find(
                (x: string) => x === line.merchandise.id
              )
            ) {
              this.toasts.push({
                id,
                lifespan: this.clear(id),
                title: line.merchandise.product.title,
                price: line.merchandise.priceV2.amount,
                properties: line.attributes.filter(
                  (x: any) => !x.key.startsWith('_')
                ),
                image: line.merchandise.image.transformedSrc,
              });
            }
          }
        } catch (err) {
          console.log(err);
        }
      });
  }
  toasts: any[] = [];

  clear(id: string) {
    setTimeout(() => {
      this.toasts = this.toasts.filter((x) => x.id !== id);
    }, 3000);
  }

  dismissAll() {
    this.toasts = [];
  }

  dismiss(toast: any) {
    this.themeService.minicartOpen();
    this.toasts = this.toasts.filter((x) => x !== toast);
  }
}
